import { useEffect, useState } from 'react'

interface TimeLeft {
  minutes: number
  seconds: number
}

export function useCountdown(startMinutes = 30): TimeLeft {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    minutes: startMinutes,
    seconds: 0,
  })

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prev) => {
        let { minutes, seconds } = prev
        seconds -= 1
        if (seconds < 0) {
          seconds = 59
          minutes -= 1
        }
        if (minutes < 0) {
          minutes = 0
          seconds = 0
        }
        return { minutes, seconds }
      })
    }, 1000)
    return () => clearInterval(timer)
  }, [])

  return timeLeft
}

export function pad(n: number): string {
  return n.toString().padStart(2, '0')
}
